import { FC } from 'react'
import { PageTitlePrefixSlot } from './page-title-prefix-slot'
import { Props } from './types'

export { PageTitlePrefixSlot } from './page-title-prefix-slot'

export const PageTitle: FC<Props> = ({
  title,
  prefix,
  withBackButton = false,
  color = 'text-title-color',
  size = 'text-[30px]',
  fontWeight = 'font-medium',
}) => {
  return (
    <div className="flex items-center gap-3">
      {withBackButton ? <PageTitlePrefixSlot /> : null}
      {prefix}
      <h1 className={`${fontWeight} ${color} ${size}`}>{title}</h1>
    </div>
  )
}
